(() => {
  function init() {
    document.querySelectorAll('[data-wheel-builder]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.closest('form');
      const productForm = form.closest('product-form');
      const variants = JSON.parse(root.querySelector('[data-wheel-variants]').textContent);
      const idInput = form.querySelector('[name="id"]');
      const model = root.querySelector('[name="properties[Vehicle model]"]');
      const year = root.querySelector('[name="properties[Model year]"]');
      const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      function update() {
        year.max = model.value === 'Dodge Durango' ? '2026' : '2023';
        let total = 49900;
        root.querySelectorAll('[data-group]').forEach(group => {
          const choice = group.querySelector('input:checked');
          if (choice) total += Number(choice.dataset.cost);
          const summary = root.querySelector('[data-summary="' + group.dataset.group + '"]');
          if (summary && choice) summary.textContent = choice.value + (Number(choice.dataset.cost) ? ' · +' + money.format(Number(choice.dataset.cost) / 100) : ' · Included');
        });
        const variant = variants.find(v => Number(v.price) === total && v.available);
        const ready = Boolean(variant);
        productForm.dataset.wheelReady = String(ready);
        if (ready) { idInput.value = variant.id; idInput.disabled = false; }
        else idInput.disabled = true;
        form.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = !ready; });
        root.querySelector('[data-wheel-total]').textContent = money.format(total / 100) + ' USD';
        const error = root.querySelector('[data-wheel-error]');
        error.hidden = ready;
        error.textContent = ready ? '' : 'This configuration is currently unavailable. Message us for help.';
        // Save the quoted price with the configuration as a visible order property.
        let priceProperty = form.querySelector('[name="properties[Build total]"]');
        if (!priceProperty) { priceProperty = document.createElement('input'); priceProperty.type = 'hidden'; priceProperty.name = 'properties[Build total]'; form.append(priceProperty); }
        priceProperty.value = money.format(total / 100) + ' USD';
      }
      root.addEventListener('change', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

